import { z } from 'zod/v4';
import { AmforiSyncCountersSchema } from './sync-counters.js';
import { AmforiSyncLastErrorSchema } from './sync-last-error.js';
import { AmforiSyncTerminalStatusSchema } from './sync-status.js';

/**
 * Payload of the `AMFORI_SYNC_REPORT` notification. Fired exactly once per run
 * by `AmforiSyncOrchestratorService.markCompleted` on the real
 * `RUNNING → terminal` transition.
 *
 * - `syncHistoryId` — the run that just settled.
 * - `companyId` — the brand the run belongs to (notification recipient scope).
 * - `status` — the terminal status the run settled into.
 * - `counters` — the final aggregate counters for the run.
 * - `lastError` — structured classification of the failure cause (FAILED only).
 */
export const AmforiSyncReportNotificationSchema = z.object({
  syncHistoryId: z.string().min(1),
  companyId: z.string().min(1),
  status: AmforiSyncTerminalStatusSchema,
  counters: AmforiSyncCountersSchema,
  lastError: AmforiSyncLastErrorSchema.optional(),
});

export type AmforiSyncReportNotification = z.infer<
  typeof AmforiSyncReportNotificationSchema
>;
